import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sIcon.png'
import _imports_1 from '@/assets/uIcon.png'
import _imports_2 from '@/assets/float.png'


const _withScopeId = n => (_pushScopeId("data-v-ddcb673a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "other-content-loading",
  class: "text-center mt-3"
}
const _hoisted_2 = { class: "fa-2x" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_4 = {
  key: 0,
  id: "other-content"
}
const _hoisted_5 = { id: "grdOther" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "status-under-staffed" }
const _hoisted_8 = { class: "status-over-staffed" }
const _hoisted_9 = { class: "status-under-staffed" }
const _hoisted_10 = { class: "status-over-staffed" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"24px","float":"right"},
  src: _imports_2,
  alt: "Float"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { style: {"text-decoration":"line-through"} }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  id: "filterModelOtherDept",
  class: "filterPanel d-none"
}
const _hoisted_27 = { class: "p-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-2" }, "Filter by: ", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 1,
  id: "other-message",
  class: "text-center mt-3"
}
const _hoisted_32 = { id: "other-message-text" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "care-assignment-container-other" }, null, -1))
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_ExportToExcelForTabs = _resolveComponent("ExportToExcelForTabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_3
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    (_ctx.isShowOtherContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_neu_card, {
              color: "plain-0",
              class: "p-0 m-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_table, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_table_row, {
                      columns: _ctx.columnHeaders,
                      header: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                          return (_openBlock(), _createBlock(_component_neu_table_heading, {
                            key: column,
                            icon: _ctx.columnIcons[column],
                            slot: column,
                            style: {"padding-top":"25px !important"},
                            onVNeuChange: ($event: any) => (_ctx.sortData($event,column))
                          }, {
                            default: _withCtx(() => [
                              ((column != 'RN Experience' || (column == 'RN Experience' && _ctx.isRNExperienceFeatureEnabled)))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (column == 'DepartmentGroup' || column == 'SkillGroup')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(column) + " ", 1),
                                          (_ctx.filterColumnList.includes(column))
                                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                key: 0,
                                                icon: ['fas', 'filter'],
                                                size: "lg",
                                                id: `filterIcon-${column}`,
                                                column: column,
                                                onClick: ($event: any) => (_ctx.onFilterVisible($event, column)),
                                                style: {"margin-left":"5px"}
                                              }, null, 8, ["id", "column", "onClick"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["icon", "slot", "onVNeuChange"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["columns"]),
                    _createVNode(_component_neu_table_body, { align: "left" }, {
                      default: _withCtx(() => [
                        (_ctx.otherDepartmentList != null && _ctx.otherDepartmentList.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.otherDepartmentList, (dept) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: dept }, [
                                _createVNode(_component_neu_table_row, {
                                  class: "departmentGroupRow",
                                  columns: _ctx.columnHeaders,
                                  slot: _ctx.column
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_neu_label, { slot: "DepartmentGroup" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: ['fas', 'caret-right'],
                                          size: "sm",
                                          class: _normalizeClass([dept.isDeptExpand ? 'collapseIcon': '']),
                                          onClick: ()=> dept.isDeptExpand = !dept.isDeptExpand,
                                          style: {"padding-right":"5px"}
                                        }, null, 8, ["class", "onClick"]),
                                        _createElementVNode("b", null, _toDisplayString(dept.DepartmentName), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dept.SkillList, (skillVol) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: skillVol }, [
                                            (skillVol.StaffVolume < 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode("   "),
                                                  _createElementVNode("span", _hoisted_7, _toDisplayString(skillVol.SkillName) + " (" + _toDisplayString(skillVol.StaffVolume) + ")", 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (skillVol.StaffVolume > 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createTextVNode("   "),
                                                  _createElementVNode("span", _hoisted_8, _toDisplayString(skillVol.SkillName) + " (" + _toDisplayString(skillVol.StaffVolume) + ")", 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["columns", "slot"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dept.SkillList, (skill) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: skill }, [
                                    _createVNode(_component_neu_table_row, {
                                      columns: _ctx.columnHeaders,
                                      slot: _ctx.column,
                                      class: _normalizeClass([!dept.isDeptExpand ? 'd-none': '','skillGroupRow'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_neu_label, { slot: "SkillGroup" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: ['fas', 'caret-right'],
                                              size: "sm",
                                              class: _normalizeClass([skill.isSkillExpand ? 'collapseIcon': '']),
                                              onClick: ()=> skill.isSkillExpand = !skill.isSkillExpand,
                                              style: {"padding-right":"5px"}
                                            }, null, 8, ["class", "onClick"]),
                                            _createElementVNode("b", null, _toDisplayString(skill.SkillName), 1),
                                            (skill.StaffVolume < 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode("   "),
                                                  _createElementVNode("span", _hoisted_9, "Under Staffed (" + _toDisplayString(skill.StaffVolume) + ")", 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (skill.StaffVolume > 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createTextVNode("   "),
                                                  _createElementVNode("span", _hoisted_10, "Over Staffed (" + _toDisplayString(skill.StaffVolume) + ")", 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["columns", "slot", "class"]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.otherGridData, (dataItem) => {
                                      return (_openBlock(), _createBlock(_component_neu_table_row, {
                                        columns: _ctx.columnHeaders,
                                        slot: _ctx.column,
                                        key: dataItem,
                                        uid: dataItem.uid,
                                        staffId: dataItem.staffId,
                                        class: _normalizeClass([dataItem.profileCharge && dataItem.charge? 'chargeAssignment': '',
                                                   !dept.isDeptExpand ? 'd-none' : '' ,
                                                   !skill.isSkillExpand ? 'd-none' : '' ,
                                                   (dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length>
                                        0) || dataItem.isCancelled) ? 'cancelledAssignment': '',
                                        dataItem.origDepartmentId !== dataItem.departmentId && !(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'floatedAssignment' : '']),
                                        onClick: ($event: any) => (_ctx.onRowSelect(dataItem))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_neu_label, {
                                            slot: "Name",
                                            title: dataItem.name
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.name) + " ", 1),
                                              (dataItem.charge)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                                    _createVNode(_component_font_awesome_icon, {
                                                      icon: ['fa', 'user-md'],
                                                      size: "sm",
                                                      style: {"float":"right","font-size":"16px"}
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (dataItem.associationType === _ctx.associationTypes.secondary)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_14))
                                                : _createCommentVNode("", true),
                                              (dataItem.associationType === _ctx.associationTypes.unassociated)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17))
                                                : _createCommentVNode("", true),
                                              (dataItem.isFloat)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_20))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Skill",
                                            title: dataItem.skillLevelDescription,
                                            class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': ''])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.skillLevelDescription), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title", "class"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Comps",
                                            style: {"white-space":"nowrap"},
                                            class: _normalizeClass(["col-comps", [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '']])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.competencyCodes), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Department",
                                            title: dataItem.departmentName,
                                            class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': ''])
                                          }, {
                                            default: _withCtx(() => [
                                              (dataItem.origDepartmentId !== dataItem.departmentId)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                                    _createTextVNode(_toDisplayString(dataItem.departmentName) + " ", 1),
                                                    _hoisted_22,
                                                    _createElementVNode("span", _hoisted_23, _toDisplayString(dataItem.origDepartmentName), 1)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(dataItem.departmentName), 1))
                                            ]),
                                            _: 2
                                          }, 1032, ["title", "class"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Shift",
                                            class: _normalizeClass([dataItem.overtimeShift ? 'gridOverTime': '',
                                                   (dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length>
                                            0) || dataItem.isCancelled) ? 'strikethrough': ''])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.shiftCode), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Start Time",
                                            class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': ''])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setGridTimeFormat(dataItem.actualStartTime)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "End Time",
                                            class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': ''])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setGridTimeFormat(dataItem.actualEndTime)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Type",
                                            class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': ''])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.employeeType), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Hours",
                                            class: _normalizeClass([dataItem.isOvertime ? 'gridOverTime': ''])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.hours), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"]),
                                          (dataItem.rnExperienceFeatureEnabled)
                                            ? (_openBlock(), _createBlock(_component_neu_label, {
                                                key: 0,
                                                slot: "RN Experience",
                                                class: _normalizeClass([dataItem.rnExperience == '< 1 Year' ? 'rn-experience': ''])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(dataItem.rnExperience), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["class"]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_neu_label, {
                                            slot: "Hire Date",
                                            title: _ctx.setGridDateFormat(dataItem.hireDate)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.hireDate)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Seniority Date",
                                            title: _ctx.setGridDateFormat(dataItem.seniorityDate)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.seniorityDate)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Last Cancelled",
                                            title: _ctx.setGridDateFormat(dataItem.lastCanceledDate)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.lastCanceledDate)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Last Floated",
                                            title: _ctx.setGridDateFormat(dataItem.lastFloatedDate)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.lastFloatedDate)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, { slot: "Notes" }, {
                                            default: _withCtx(() => [
                                              (dataItem.hasNotes)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                                    _createVNode(_component_font_awesome_icon, {
                                                      icon: ['fa', 'sticky-note'],
                                                      size: "sm"
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["columns", "slot", "uid", "staffId", "class", "onClick"]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              (_ctx.filterColumn == 'Hours')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    "data-role": "dropdownlist",
                    class: "neu-select mb-2 filterInput",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedNumberFilter) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberFilter, (numFtr) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: numFtr.Id,
                        key: numFtr.Id
                      }, _toDisplayString(numFtr.Value), 9, _hoisted_29))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.selectedNumberFilter]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    "data-role": "dropdownlist",
                    class: "neu-select mb-2 filterInput",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTextFilter) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textFilter, (txtFtr) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: txtFtr.Id,
                        key: txtFtr.Id
                      }, _toDisplayString(txtFtr.Value), 9, _hoisted_30))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.selectedTextFilter]
                  ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              }),
              (_ctx.filterColumn == 'Hours')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 2,
                    title: "Value",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.NumberfilterText) = $event)),
                    class: "neu-input mb-2 filterInput",
                    type: "number"
                  }, null, 512)), [
                    [_vModelText, _ctx.NumberfilterText]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 3,
                    title: "Value",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterText) = $event)),
                    class: "neu-input mb-2 filterInput",
                    type: "text"
                  }, null, 512)), [
                    [_vModelText, _ctx.filterText]
                  ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "submit",
                  title: "Filter",
                  class: "neu-button--primary neu-button neu-button--raised filterBtn",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onGridFilter && _ctx.onGridFilter(...args)))
                }, "Filter"),
                _createElementVNode("button", {
                  type: "reset",
                  title: "Clear",
                  class: "neu-button--primary neu-button neu-button--raised filterBtn",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onGridFilterClear && _ctx.onGridFilterClear(...args)))
                }, "Clear"),
                _createElementVNode("button", {
                  type: "button",
                  title: "Close",
                  class: "neu-button--primary neu-button neu-button--raised filterBtn",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onGridFilterClose && _ctx.onGridFilterClose(...args)))
                }, "Close")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowOtherMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.otherMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_33,
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowExportToExcel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createVNode(_component_ExportToExcelForTabs, {
            onCloseExcelTemplate: _ctx.closeOtherTabExportToExcel,
            payloadExportToExcel: _ctx.payloadExportToExcel
          }, null, 8, ["onCloseExcelTemplate", "payloadExportToExcel"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}